import { msg } from '@gonfalon/messages/msg';
import { Dialog, IconButton, Modal, ModalOverlay } from '@launchpad-ui/components';

import { ContactSalesForm, type ContactSalesFormProps } from './ContactSalesForm';

import styles from './ContactUsModal.module.css';

export type ContactUsFormModalProps = ContactSalesFormProps & {
  isOpen?: boolean;
  onCancel?(open: boolean): void;
};

export function ContactUsModal({
  isOpen,
  onCancel,
  productInterest,
  requestedFeature,
  headerText,
  onFormSubmit,
}: ContactUsFormModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <ModalOverlay isDismissable onOpenChange={onCancel} isOpen>
      <Modal className={styles.modal}>
        <Dialog>
          {({ close }) => (
            <>
              <div className={styles.close} slot="header">
                <IconButton
                  aria-label={msg('billing.contactUsModal.closeLabel')}
                  icon="cancel"
                  variant="minimal"
                  onPress={close}
                />
              </div>
              <ContactSalesForm
                requestedFeature={requestedFeature}
                productInterest={productInterest}
                headerText={headerText}
                onFormSubmit={onFormSubmit}
              />
            </>
          )}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}
